(function () {
  function init(root) {
    root.querySelectorAll('[data-lw-press-carousel]').forEach(function (carousel) {
      if (carousel.dataset.lwPressReady === 'true') return;
      var rail = carousel.querySelector('.lw-press-logos__rail');
      if (!rail) return;

      Array.from(rail.children).forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.classList.add('lw-press-logos__clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach(function (element) { element.removeAttribute('id'); });
        clone.querySelectorAll('a').forEach(function (link) { link.setAttribute('tabindex', '-1'); });
        rail.appendChild(clone);
      });

      var resumeTimer;
      rail.addEventListener('pointerdown', function () {
        clearTimeout(resumeTimer);
        rail.classList.add('is-paused');
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (eventName) {
        rail.addEventListener(eventName, function () {
          clearTimeout(resumeTimer);
          resumeTimer = setTimeout(function () { rail.classList.remove('is-paused'); }, 1500);
        });
      });
      carousel.dataset.lwPressReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
